<template>
  <div class="tnc">
    <h2>
      {{
        $t("RPAS Wilco Flight Review Terms and Conditions for Flight Reviewers")
      }}
    </h2>
    <p>{{ $t("Last Updated:") }} 2024-01-24</p>

    <h6>{{ $t("1 Rescheduling and Cancellation Policy:") }}</h6>
    <p>
      {{
        $t(
          "Flight reviewers can cancel or reschedule a session if necessary, but must provide at least 3 hours' notice directly to the client."
        )
      }}
    </p>
    <p>
      {{
        $t(
          "Cancellations should be limited to essential circumstances, such as adverse weather conditions or emergencies."
        )
      }}
    </p>

    <h6>{{ $t("2 Service Fee and Payment:") }}</h6>
    <p>
      {{ $t("RPAS Wilco charges a 30% service fee on the booking amount.") }}
    </p>
    <p>
      {{
        $t(
          "Reviewers will receive their payment for sessions conducted, minus the service fee, at the end of each month."
        )
      }}
    </p>

    <h6>{{ $t("3 Flight Review Checklist:") }}</h6>
    <p>
      {{
        $t(
          "Reviewers will be provided with a Flight Review Checklist for each session."
        )
      }}
    </p>
    <p>
      {{
        $t(
          "All items on the checklist are timestamped to ensure accuracy and accountability."
        )
      }}
    </p>
    <p>
      {{
        $t(
          "A comprehensive report based on the checklist will be provided after the session, which is auditable for quality and compliance purposes."
        )
      }}
    </p>

    <h6>{{ $t("4 Pro Subscription Benefit:") }}</h6>
    <p>
      {{
        $t(
          "Flight reviewers will have free access to RPAS Wilco’s Pro subscription, providing additional resources and tools to enhance their reviewing capabilities."
        )
      }}
    </p>

    <h6>{{ $t("5 Client Rescheduling Policy:") }}</h6>
    <p>
      {{
        $t(
          "Reviewers should be aware that clients can reschedule but not cancel a session, following the 48-hour notice policy to the reviewer."
        )
      }}
    </p>

    <h6>{{ $t("6 Changes to Terms and Conditions:") }}</h6>
    <p>
      {{
        $t(
          "RPAS Wilco reserves the right to modify these terms and conditions at any time. Changes will be effective immediately upon posting on our website."
        )
      }}
    </p>

    <h6>{{ $t("7 Contact Information:") }}</h6>
    <p>
      {{ $t("For queries or concerns, please contact contact@rpaswilco.com.") }}
    </p>
  </div>
</template>
<script>
export default {
  name: "tnc"
};
</script>
<style lang="scss">
.tnc {
  padding: 20px;
  background-color: #ddd;
}
</style>
